import { MenuIdInsight } from '@jira/navigation-apps__constants/src/MenuIdInsight.tsx';
import { workspaceResource } from '@jira/servicedesk__insight-common-services-workspace-context/src/workspaceResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { getServicedeskPageContextResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { toPackageName, APP_NAMES } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { servicedeskCmdbAssetsReportsRoute } from '@jira/router-routes__servicedesk-cmdb-routes/src/servicedeskCmdbAssetsReportsRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import {
	AssetsReportsNav4HomePage,
	LazyServicedeskCmdbDefaultReportsRedirect,
	LazyServicedeskCmdbAssetsReportsNav4HomePage,
} from './ui/reports/index.tsx';
import { AssetsAppRedirect } from './ui/redirect/assets-app-redirect/index.tsx';

export const servicedeskCmdbAssetsReportsRouteEntry: Route = createEntry(
	servicedeskCmdbAssetsReportsRoute,

	() => ({
		group: 'servicedesk',
		layout: globalLayout,
		navigation: { menuId: MenuIdInsight },

		// eslint-disable-next-line no-restricted-syntax
		component: fg('assets_as_an_app_v2') ? AssetsAppRedirect : AssetsReportsNav4HomePage,

		resources: [
			...getNavigationResources(),
			...getServicedeskPageContextResources(),
			workspaceResource,
		],

		forPaint: [
			LazyAtlassianNavigation,
			LazyServicedeskCmdbDefaultReportsRedirect,
			LazyServicedeskCmdbAssetsReportsNav4HomePage,
		],

		meta: {
			reporting: {
				id: APP_NAMES.INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT,
				packageName: toPackageName(APP_NAMES.INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT),
				teamName: 'ITSM SAGA',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
